import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { RoutingRulesCardI } from '..';
import info from '../../../../../../assets/images/icons/info.svg';
import FilterRadioButton from '../../../../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../../../../components/FilterRadioButtonsContainer';
import OpacityAnimation from '../../../../../../components/OpacityAnimation';
import { ConditionalInputGroup, Container, Group, RangeSliderContainer } from '../../../styles';

export default function RoutingRulesCard({
  copyGoingToReturn,
  setCopyGoingToReturn,
  hasAffreightment,
  setHasAffreightment,
  hasKmLimit,
  setHasKmLimit,
  selectedKmLimit,
  setSelectedKmLimit,
  selectedWalkDistance,
  setSelectedWalkDistance,
  transfersBehavior,
  setTransfersBehavior,
  handleKmLimitSelection,
  handleWalkDistanceSelection,
}: RoutingRulesCardI) {
  return (
    <Container>
      <div className="card-title">
            Itinerário
      </div>
      <Group>
        <div className="title">
          <div>
            Espelhar trajeto da ida inversamente na volta?
            {' '}
            <img src={info} alt="info" title="O resultado da volta sempre será o inverso do resultado da ida. Isso otimiza o tempo de processamento de uma roteirização, porém pode diminuir a precisão do mesmo." />
          </div>
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={copyGoingToReturn} onClick={() => setCopyGoingToReturn(true)}>
                  Sim
          </FilterRadioButton>
          <FilterRadioButton selected={!copyGoingToReturn} onClick={() => setCopyGoingToReturn(false)}>
                  Não
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </Group>
      <Group>
        <div className="title">
          <div>
            Utilizar fretamento na roteirização?
            {' '}
            <img src={info} alt="info" title="Levará em consideração as linhas de fretamento desta empresa (caso tenha) nas roteirizações" />
          </div>
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={hasAffreightment} onClick={() => setHasAffreightment(true)}>
                  Sim
          </FilterRadioButton>
          <FilterRadioButton selected={!hasAffreightment} onClick={() => setHasAffreightment(false)}>
                  Não
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </Group>
      <Group>
        <div className="title">
          <div>
            Utilizar limitador de Km?
            {' '}
            <img src={info} alt="info" title="Apresentará o resultado em que a distância total do trajeto tenha até a quilometragem definida neste campo, para não levar em consideração trajetos muito longos, que podem ser mais baratos, porém muito cansativo para o colaborador. Caso nenhum resultado seja encontrado conforme a limitação de quilometragem, o trajeto mais curto possível será mostrado." />
          </div>
        </div>
        <ConditionalInputGroup>
          <FilterRadioButtonsContainer notOverflow>
            <FilterRadioButton selected={hasKmLimit} onClick={() => setHasKmLimit(true)}>
                  Sim
            </FilterRadioButton>
            <FilterRadioButton selected={!hasKmLimit} onClick={() => setHasKmLimit(false)}>
                  Não
            </FilterRadioButton>
          </FilterRadioButtonsContainer>

          {hasKmLimit && (
            <OpacityAnimation>
              <RangeSliderContainer>
                <header>
                  {` ${selectedKmLimit[1]}km`}
                </header>
                <RangeSlider
                  min={5}
                  max={50}
                  value={selectedKmLimit}
                  onThumbDragEnd={() => handleKmLimitSelection(selectedKmLimit)}
                  onInput={(evt: number[]) => setSelectedKmLimit(evt)}
                  className="single-thumb"
                  thumbsDisabled={[true, false]}
                  rangeSlideDisabled
                />
              </RangeSliderContainer>
            </OpacityAnimation>
          )}
        </ConditionalInputGroup>
      </Group>

      <Group>
        <div className="title">
          <div>
            Limite de distância caminhada
            {' '}
            <img src={info} alt="info" title="Define qual a distância máxima caminhada permitida nas etapas do trajeto. Quanto menor a distância, maior a possibilidade de não ser encontrado um resultado, e maior as chances do resultado ter um valor mais elevado em relação a uma distância caminhada maior." />
          </div>
        </div>
        <RangeSliderContainer>
          <header>
            {` ${selectedWalkDistance[1]}m`}
          </header>
          <RangeSlider
            min={500}
            max={2000}
            value={selectedWalkDistance}
            onThumbDragEnd={() => handleWalkDistanceSelection(selectedWalkDistance)}
            onInput={(evt: number[]) => setSelectedWalkDistance(evt)}
            className="single-thumb"
            thumbsDisabled={[true, false]}
            step={50}
            rangeSlideDisabled
          />
        </RangeSliderContainer>
      </Group>

      <Group>
        <div className="title">
          <div>
            Comportamento referente à baldeações:
            {' '}
            <img src={info} alt="info" title="O comportamento padrão prioriza até 2 baldeações, um bom equilíbrio entre tempo/distância, quantidade de baldeações e custo. Caso seja definido baldeações ilimitadas, os resultados apresentados terão o menor tempo/distância menores, porém podem ter muitas baldeações, e, consequentemente um cuso maior. O mínimo de baldeações possíveis poderá ocasionar em um tempo/distância muito longos, porém com a menor quantidade de baldeações possíveis, e, consequentemente, um custo menor" />
          </div>
        </div>
        <FilterRadioButtonsContainer>
          <FilterRadioButton selected={transfersBehavior === 'default'} onClick={() => setTransfersBehavior('default')}>
                  Padrão
          </FilterRadioButton>
          <FilterRadioButton selected={transfersBehavior === 'unlimited'} onClick={() => setTransfersBehavior('unlimited')}>
                  Permitir baldeações ilimitadas
          </FilterRadioButton>
          <FilterRadioButton selected={transfersBehavior === 'minimun'} onClick={() => setTransfersBehavior('minimun')}>
                  Mínimo de baldeações possíveis
          </FilterRadioButton>
        </FilterRadioButtonsContainer>
      </Group>
    </Container>
  );
}
